import styled from "styled-components";

export const Navbar = styled.nav`
  background: white;
  position: sticky;
  top: 0;
  z-index: 1000; 
  width: 100%;
`;
